export default (_this) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: _this.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'right',
    width: 140,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'stockSellNo',
    align: 'center',
    minWidth: 140,
    title: _this.$l('form_label_sell_no') || '销售单号',
    showHeaderOverflow: 'title'
  },
  {
    field: 'useSalesName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    title: _this.$l('form_label_sales_name') || '销售人员',
    showHeaderOverflow: 'title'
  },
  {
    field: 'useCustName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 280,
    title: _this.$l('form_label_customer') || '收货客户',
    showHeaderOverflow: 'title'
  },
  {
    field: 'borrowDate',
    align: 'center',
    minWidth: 120,
    title: _this.$l('form_label_borrow_date') || '销售日期',
    showHeaderOverflow: 'title'
  },
  {
    title: _this.$l('INDEX.Status') || '单据状态',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'status' }
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: _this.$l('INDEX.creator') || '创建人',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: 'title'
  },
  {
    headerAlign: 'center',
    field: 'createDate',
    title: _this.$l('INDEX.create_date') || '创建时间',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: 'title'
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: _this.$l('INDEX.table_label_modified_by') || '修改人',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: 'title'
  },
  {
    headerAlign: 'center',
    field: 'modifyDate',
    title: _this.$l('INDEX.table_label_modification_date') || '修改时间',
    minWidth: 170,
    showHeaderOverflow: 'title'
  }
]
